import $ from 'jquery';
import config from '../../config';
const URL_API = config.urlApi+'controlador/tipo_gasto/getTipoEgresos.php';

export default function getTipoEgresos(){
    return $.ajax({
        url: URL_API,
        type: 'GET'
    })
}